import ddt from '@wix/da-ddt';

const logger = ddt.createLogger('devpage');
export default logger;
